export default __webpack_public_path__ + "static/media/Visibilidade OFF.a99a40ee.svg";